<template>
  <div>
    <div class="announcement section">
      <p>{{ $t("confirmInAppPurchase.title") }}</p>
      <div class="description">
        <div class="margin-bottom">
          {{ $t("confirmInAppPurchase.description") }}
        </div>
      </div>
      <router-link class="button-design back" :to="{ name: 'paymentManagement' }">{{ $t("confirmInAppPurchase.backButton") }}</router-link>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
.margin-bottom {
  margin-bottom: 15px;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 30px;
  p {
    text-align: center;
  }
}

.announcement {
  p {
    font-size: 1.5em;
    font-weight: var(--font-weight-bold);
    margin-top: 0;
  }

  .description {
    max-width: 600px;
  }
}

.button-design {
  margin: 20px;
  padding: 15px 50px;
  border-radius: var(--radius-rounded);
  font-weight: var(--font-weight-bold);
  border-style: none;
  color: var(--color-text-on-fixed-bg);
  text-decoration: none;
  cursor: pointer;

  &.back {
    background-color: var(--color-primary);
  }
}
</style>
